export default __webpack_public_path__ + "static/media/tailwindcss.0186da1a.svg";